
<ion-content [fullscreen]="true">

  <div class="tempo">
    <div
      style="width: 75%; display: flex; align-items: center; justify-content: center; flex-direction: column; margin-bottom: 32px;">
      <img style="width: 50px;" src="../../../assets/icon/icon.png" />
      <ion-label class="title" color="primary">Tempo</ion-label>
    </div>
    <div style="width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column;">

      <ion-label class="subtitle" color="tertiary">Scegli una nuova password per il tuo account</ion-label>
      <div style="width: 75%">
        <ion-input type="password" label="Password" [pattern]="passwordPattern" labelPlacement="floating"
          errorText="Deve contenere almeno una lettera maiuscola, un numero, un carattere speciale ed essere lunga almeno 8 caratteri"
          helperText="Scegli una password" [(ngModel)]="suec.pass">
        </ion-input>
        <ion-input type="password" label="Ripeti password" labelPlacement="floating"
          errorText="Le password non coincidono" helperText="Ripeti la password scelta" [(ngModel)]="suec.rpass">
        </ion-input>

      </div>

      <ion-button [disabled]="!isValidPassword() && !passwordsMatches()" style="margin-top: 16px;" (click)="resetPassword()" size="large">
        <ion-label>MODIFICA PASSWORD</ion-label>
      </ion-button>


    </div>
  </div>

</ion-content>